import React from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import DragVerticalIcon from 'mdi-react/DragVerticalIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import SquareIconButton from '../../../../shared/components/custom/SquareIconButton';
import { getQuestionType } from './QuestionType';
import { partial } from '../../../../util/translation/translation';

// A shared question in the library: drag it into the form, or use Add.
export default function LibraryQuestionItem(props) {
  const { question, added, onAdd, onEdit, onDelete } = props;
  const qT = partial('question');
  const type = getQuestionType(question.question.question_type);

  return (
    <div className={`qb-library-item${added ? ' qb-library-item--added' : ''}`}>
      {/* Questions already in the form can't be dragged in again */}
      <span className="qb-library-item__grip" aria-hidden>
        {!added && <DragVerticalIcon size={18} />}
      </span>
      <div className="qb-library-item__text">
        <span className="qb-library-item__question">
          {question.question.question}
        </span>
        {type && <span className="qb-library-item__type">{type.label}</span>}
      </div>
      {added ? (
        <span className="qb-library-item__added">
          <CheckIcon size={16} />
          {qT('inForm')}
        </span>
      ) : (
        <button
          type="button"
          className="qb-add-btn"
          onClick={() => onAdd(question)}
        >
          <PlusIcon size={14} />
          {qT('addToForm')}
        </button>
      )}
      <SquareIconButton
        icon={<EditOutlineIcon />}
        title={qT('editQuestion')}
        id={`library-edit-${question.id}`}
        onClick={() => onEdit(question)}
      />
      <SquareIconButton
        icon={<DeleteOutlineIcon />}
        title={qT('deleteFromLibrary')}
        tone="danger"
        id={`library-delete-${question.id}`}
        onClick={() => onDelete(question)}
      />
    </div>
  );
}
